import { render, staticRenderFns } from "./bottom_banner.vue?vue&type=template&id=6148931c&lang=pug"
import script from "./bottom_banner.vue?vue&type=script&lang=js"
export * from "./bottom_banner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports